import { render, staticRenderFns } from "./FeatureOff.vue?vue&type=template&id=ac439a4c"
import script from "./FeatureOff.vue?vue&type=script&lang=ts"
export * from "./FeatureOff.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports